import React from 'react';

import ProcurementCategoriesTable from '../../procurement_categories/ProcurementCategoriesTable';
import { useProcurement } from '../context/ProcurementContext';

const ProcurementCategoryTab = () => {
    const { routes } = useProcurement();

    return (
        <ProcurementCategoriesTable
            indexUrl={routes.fetchCategoriesUrl}
            updateUrl={routes.updateCategoryUrl}
            createUrl={routes.createCategoryUrl}
            deleteUrl={routes.deleteCategoryUrl}
        />
    );
};

export default ProcurementCategoryTab;
